module.exports = __webpack_public_path__ + "static/media/icon-email.c90d96c2.svg";